export default {
  api: [
    {
      name: 'wxPayList',
      method: 'POST',
      desc: '微信记录查询',
      path: '/query/list'
    },
    {
        name: 'payStatus',
        method: 'GET',
        desc: '支付状态',
        path: '/dict/status'
      },
  ],
  BASE_URL: '/wx/pay'
}



// WEBPACK FOOTER //
// ./src/api/apis/wechat/wxpay.js